<template>
  <div>
  
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :loader="'dots'"
      :height="150"
      :width="150"
      :color="'#F1557A'"
      :is-full-page="fullPage"
    ></loading>
    <!--<video id="demo-player" class="cld-video-player" data-cld-show-logo="false">></video>-->
    <d-col
      v-for="(post, idx) in PostsListOne"
      :key="idx"
      lg="3"
      md="6"
      sm="12"
      class="mb-4 card-container"
    >
      <d-card class="card-small card-post card-post--1 video-card">
        <div class="card-width">
          <!--<cld-video :publicId="`${post.video_id}`" controls="true" showLogo="false" analytics="false">
                      <cld-transformation
                        gravity= "auto"
                        crop="fill"
                        width="310"
                        height="250"
                       aspectRatio="1:1"
                      />
          </cld-video> -->

          <video
            :id="`demo-player-${idx}`"
            data-cld-show-logo="false"
          ></video>
        </div>

       <div class="card-box">
            <div class="card-post__author d-flex">
              <!-- <a
                href="#"
                class="card-post__author-avatar card-post__author-avatar--small"
                :style="{ backgroundImage: 'url(\'' + post.thumbnail + '\')' }"
              >Written by {{ post.thumbnail }}</a> -->
              <div class="sent-to-box">
                <p class="card-text d-inline-block mb-1 message-to">Sent To:</p>
                <h6 class="card-title">
                  <span class="text-fiord-blue">
              {{
                post.users_sent_to ?
              post.users_sent_to && post.users_sent_to.length >= 4
              ? post.users_sent_to[0].first_name +
              ", " +
              post.users_sent_to[1].first_name +
              ", " +
              post.users_sent_to[2].first_name +
              " & " +
              (post.users_sent_to.length - 3) +
              Others
              : post.users_sent_to && post.users_sent_to.length == 3
              ? post.users_sent_to[0].first_name +
              ", " +
              post.users_sent_to[1].first_name +
              " & " +
              post.users_sent_to[2].first_name
              : post.users_sent_to && post.users_sent_to.length == 2
              ? post.users_sent_to[0].first_name +
              " & " +
              post.users_sent_to[1].first_name
              : post.users_sent_to && post.users_sent_to.length == 1
              ? post.users_sent_to[0].first_name
              : "no user"
              :
              'no user'
              }}
            </span>
                </h6>
              </div>
             
              <!-- <avatar  :username="`${post.admin.first_name}-${post.admin.last_name}`" backgroundColor="#F2557A" color="#ffffff"></avatar> -->
            </div>
            </div>
            <d-card-body class="sent-to-card">
               <span class="timestamp">{{post.admin ? post.admin.first_name : ''}} {{post.admin ? post.admin.last_name : ''}}</span>
                <span class="text-muted timestamp">{{moment(post.createdAt).format("MM/DD/YYYY hh:mm")}}</span>
            </d-card-body>
         
    
        <d-card-body class="stat-line" >
          <span class="card-text d-inline-block mb-1 mt-1 stat-line-stat">{{post.video_page_opened}} Opens</span>
          <span class="card-text d-inline-block mb-1 mt-1 stat-line-stat">{{post.video_views}} Plays</span>
          <span
            class="card-text d-inline-block mb-1 mt-1 stat-line-stat"
          >${{post.donations_collected}} Donated</span>
          <a  target="_blank" class="link-launch"  v-bind:href="getUrl(post)"> <i class="material-icons">launch</i></a>
        </d-card-body>
      </d-card>
    </d-col>
    
    <d-row v-if="this.prevPage && this.nextPage" class="load-more-row">
      <d-col v-if="this.prevPage" lg="6" md="6" sm="6"  class = "mb-4" >
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous... </d-button>
        </span>
      </d-col>
      <d-col  lg="6" md="6" sm="6" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More.. </d-button>
        </span>
      </d-col>
    </d-row>
      <d-row v-if="!this.nextPage && this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous...  </d-button>
        </span>
      </d-col>
    </d-row>
    <d-row v-if="this.nextPage && !this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More.. </d-button>
        </span>
      </d-col>
    </d-row>

  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import Avatar from "vue-avatar";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      PostsListOne:[],
      isLoading: true,
      player: null,
      prevPage:null,
      page:1,
      nextPage: null,
      loadNum: 12,
      fullPage: true,
      linkURL: 'https://easyclick.givemagicstories.com/?video_id=videos%2F5e42efdc353c460004621925_wxspiy&user_id=5e3dab3d4aae04000480551e'
    };
  },
  mounted() {
    analytics.track("Viewed Sent Videos");
    window._wq = window._wq || [];
    _wq.push({
      id: "5bbw8l7kl5",
      options: {
        autoPlay: false,
        //  videoFoam: true,
        controlsVisibleOnLoad: false,
        playbar: false,
        // email: "lennythedog@wistia.com",
        // endVideoBehavior: "loop",
        fullscreenButton: false,
        // googleAnalytics: true,
        //  qualityControl: false,
        volumeControl: true,
        settingsControl: false,
        playButton: true,
        playerColor: "#f2557a",
        // seo: true,
        // stillUrl: "https://my-awesome-website.com/my-thumbnail-url.jpg",
        // volume: 0.5,
        wmode: "transparent",
        doNotTrack: true
      }
    });
  },
  computed: {
    ...mapState({
      videoType: state => state.dash.type,
      video: state => state.dash.fetchData
    })
  },
  watch: {
    videoType(e) {
      if (e === "FETCH_DASHBOARDVIDEO_SUCCESS") {
        this.isLoading = false;
        this.page = this.video.page
        this.nextPage = this.video.nextPage
        this.prevPage= this.video.prevPage
        const video = this.video.docs;
        this.PostsListOne = video;
        const cld = cloudinary.Cloudinary.new({
          cloud_name: "givemagic",
          secure: true
        });

        if(this.PostsListOne && this.PostsListOne.length) {
          setTimeout(()=>{
            this.PostsListOne.map((item,index) => {
              this.player = cld.videoPlayer(`demo-player-${index}`, {
                showLogo: false,
                controls: true,
                colors: { accent: item.settings.primary_color },
                transformation: {
                  crop: "fill",
                  height: 268,
                  gravity: "auto",
                  aspectRatio: "1:1"
                },
                fluid: true
                //analytics: true
              });

              this.player.source(item.video_id, {
                colors: { accent: "green" },
                textTracks: {
                  captions: {
                    label: "English captions",
                    language: "en",
                    default: true,
                    url: item.video_subtitle
                  },
                  subtitles: [
                    {
                      label: "English subtitles",
                      language: "en",
                      url: item.video_subtitle
                    }
                  ]
                }
              });

            })
          },1000)
        }

      }else if(e == 'FETCH_DASHBOARDVIDEO_REQUEST'){
        this.isLoading = true;
      }
    }
  },
  methods: {
    getUrl(post){
      if(post.users_sent_to && post.users_sent_to[0] && post.users_sent_to[0].id) {
      return this.linkURL = `https://${post.settings.workspace_name}.givemagicstories.com/?video_id=${post.video_id}&user_id=${post.users_sent_to[0]._id}`;
    //  return this.linkURL = 'https://' + this.video[idx].settings.workspace_name + '.givemagicstories.com/?video_id=' + this.video[idx].video_id + '&user_id=' + this.video[idx].users_sent_to[0].id;
      }

    },
  
    loadMoreVideos() {
      // this.loadNum = this.loadNum + 8;
      if(this.nextPage){
        this.PostsListOne=[]
        const  data = this.nextPage
        this.$store.dispatch("fetchSentVideo" , data)
      }
    },
    loadPreviousVideos(){
      if(this.prevPage){
        this.PostsListOne=[]
        const  data = this.prevPage
        this.$store.dispatch("fetchSentVideo" , data)
      }
    },
    moment: function (e) {
      return moment(e);
    }
  },
  created() {
    const  data = 1
    this.$store.dispatch("fetchPendingVideo");
    this.$store.dispatch("fetchSentVideo",data);
  },
  components: {
    Avatar,
    Loading
  }
};
</script>
<style lang="scss">
.message-to {
  font-size: 10px;
  text-transform: uppercase;
}
.video-style .cld-video-player {
  height: 200px !important
}

.stat-line {
  font-size: 0.8rem !important;
}

.card-post__image {
  min-height: 10.3125rem;
}
.card-post__author {
  position: relative !important;
  left: 0px;
  bottom: 10px !important;
  margin-top: 0px;
}
.card-post__author-avatar--small {
  width: 3.1875rem;
  height: 3.1875rem;
}
.card-small {
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
  background: #fff;
}
.video-card {
  position: relative;
  width: auto;
}
.card-width {
  display: flex;
  overflow: hidden;
  height: 308px !important;
}
.play-button {
  position: absolute;
  z-index: 10001;
  left: 28%;
  top: 10%;
  cursor: pointer;
  background: linear-gradient(#f4f5f8, #f1f3f6);
}

.stat-line {
  padding: 5px !important;
  margin: 0 auto;
  background: #f0f0f1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 1.2em;
  color: #212143;
}
.stat-line-stat {
  padding: 4px;
  text-align: center;
}
.load-more {
  display: flex;
  justify-content: center;
}
.load-more-row {
  margin-top: 25px;
  margin-bottom: 25px;
  width: 100%;
  height: 100%;
}

.link-launch {
  cursor: pointer;
  margin-left:5px;
  font-size:16px;
}
.vue-avatar--wrapper {
  zoom: 0.75;
}
</style>
